module.exports = __webpack_public_path__ + "img/Home_64x64.be311dc8.png";